(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .factory('ImageFactory', ImageFactory);

    ImageFactory.$inject = ['$rootScope'];

    function ImageFactory($rootScope) {
		function drawAddrImages() {
			var input;
			if ($rootScope.name) {
				input = $rootScope.name;
			}

			if (!input) input = "";

			/// The outside wrapper div
			var canvasWrapper = $('.container-left');
			// Get wrapper's width & height
			var cw = canvasWrapper[0].clientWidth;
			var ch = canvasWrapper[0].clientHeight;
			var widthFactor = cw / input.length;

			/// Assume image always fills the whole wrapper, so we don't need to set its width and height
			/// The overlay canvas
			var canvas = document.getElementById("name-name-overlay");
			// Set canvas to be same width & height as the wrapper
			canvas.width = cw;
			canvas.height = ch;

			/// Computation
			var relativeFontSize, rx, ry, x, y, nameLen = input.length;

			if (window.innerWidth > 1000 && nameLen < 6) {
				relativeFontSize = 100;
			}
			else if (window.innerWidth < 380) {
				relativeFontSize = Math.floor(0.2 * Math.pow(nameLen, 2) - 7.7605 * nameLen + 90.51);
			}
			else if (window.innerWidth < 769) {
				relativeFontSize = Math.floor(0.2819 * Math.pow(nameLen, 2) - 10.359 * nameLen + 115.44);
			}
			else relativeFontSize = Math.floor(-0.0073 * Math.pow(widthFactor, 2) + 1.8223 * widthFactor - 10.437);
			rx = 0.5; // Relative position on canvas, X axis
			ry = 0.5; // Relative position on canvas, Y axis

			x = rx * cw;
			y = ry * ch;

			/// Drawing 
			var ctx = canvas.getContext("2d");
			// Erase the canvas before a new drawing
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.font = "normal " + relativeFontSize + "px Arial";
			ctx.fillStyle = "white";
			ctx.textAlign = "center";
			ctx.textBaseline = "middle";
			ctx.fillText(input, x, y);
		}

        var imageFactory = {
            drawAddrImages: drawAddrImages
        };

        return imageFactory;
    };

})();